export const MAX_METRIC_CARD_ROW = 3;
export const MAX_METRIC_CARD_COLUMN = 6;
export const MIN_METRIC_CARD_WIDTH = 200;
export const METRIC_CARD_HEIGHT = 150;
